export default {
  GET_QUOTATIONS: (state) => state.quotations,
  GET_QUOTATION: (state) => state.quotation,
  GET_QUOTATION_STATUSES: (state) => state.statuses,
  GET_QUOTATION_ACTIONS: (state) => state.actions,
};
